import React, { Component } from 'react'
import styled from 'styled-components'
import { SquareMinus, SquarePlus } from 'app/assets/icons'
import { FormattedMessage } from 'react-intl'
import { Field } from 'formik'
import { fonts, SmallText } from 'app/common/typography'
import { colors } from 'app-v2/design-systems/theme'

const { bbqBrown } = colors

type Props = {
    name: string,
    minValue: number,
    maxValue: number,
    labelKey: string,
    className?: string,
    setFieldValue: Function,
    value: number,
    color?: string
}

type State = {
    value: number
}

class Counter extends Component<Props, State> {
    state = {
        value: this.props.minValue
    }

    decrement = () => {
        const { name, minValue, setFieldValue } = this.props
        let { value } = this.state
        if (value <= minValue) {
            return
        }
        value--
        this.setState({ value })
        setFieldValue(name, value)
    }

    increment = () => {
        const { name, maxValue, setFieldValue } = this.props
        let { value } = this.state
        if (value >= maxValue) {
            return
        }
        value++
        this.setState({ value })
        setFieldValue(name, value)
    }

    render() {
        const {
            name,
            labelKey,
            className,
            minValue,
            maxValue,
            color
        } = this.props
        let { value } = this.state
        return (
            <CounterContainer>
                <FormattedMessage id={labelKey}>
                    {(text: string) => (
                        <StyledSmallText color={color}>{text}</StyledSmallText>
                    )}
                </FormattedMessage>
                <Content>
                    <IconContainer
                        disabled={value <= minValue}
                        onClick={this.decrement}>
                        <SquareMinus color={color} />
                    </IconContainer>
                    <StyledField
                        color={color}
                        name={name}
                        type="text"
                        disabled
                        className={className}
                        value={value}
                    />
                    <IconContainer
                        disabled={value >= maxValue}
                        onClick={this.increment}>
                        <SquarePlus color={color} />
                    </IconContainer>
                </Content>
            </CounterContainer>
        )
    }
}

const CounterContainer = styled.div`
    margin-top: 20px;
`

const Content = styled.div`
    display: flex;
    align-items: center;
    margin-top: 8px;
    user-select: none;
`

const StyledField = styled(Field)`
    font-family: ${fonts.roboto};
    color: ${props => props.color && props.color};
    background: none;
    border: none;
    width: 40px;
    height: 40px;
    text-align: center;
    &[disabled] {
        opacity: 1;
    }
`

const IconContainer = styled.i`
    ${props => (props.disabled ? 'opacity: 0.2' : 'cursor: pointer')};
`

const StyledSmallText = styled(SmallText)`
    font-family: ${fonts.flameSansRegular};
`

export { Counter }
